import { useEffect } from 'react'
import { useOfflineStore } from '@renderer/stores/offlineStore'
import { useSubscriptionStore } from '@renderer/stores/subscriptionStore'
import { useSettingsStore } from '@renderer/stores/settingsStore'

export const useSubscriptionCache = (): { isSubscriptionCacheValid: boolean } => {
  const { updateSubscriptionCache, isSubscriptionCacheValid } = useOfflineStore()
  const { type: subscriptionType, proTrialExpiresAt } = useSubscriptionStore()
  const { activationCode } = useSettingsStore()

  // Cache subscription when it's updated
  useEffect(() => {
    if (subscriptionType && activationCode) {
      const now = new Date()
      const expiresAt = proTrialExpiresAt
        ? new Date(proTrialExpiresAt)
        : new Date(now.getTime() + 12 * 60 * 60 * 1000) // 12 hours default

      updateSubscriptionCache({
        token: activationCode,
        type: subscriptionType as 'free' | 'starter' | 'professional' | 'enterprise' | 'protrial',
        verifiedAt: now,
        expiresAt,
        offlineAllowed: ['professional', 'enterprise', 'protrial'].includes(
          subscriptionType.toLowerCase()
        )
      })
    }
  }, [subscriptionType, activationCode, proTrialExpiresAt, updateSubscriptionCache])

  return {
    isSubscriptionCacheValid: isSubscriptionCacheValid()
  }
}
